export default '<svg viewBox="0 0 98 84" version="1.1">' +
  '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">' +
  '<polyline id="fadeinout" data-stroke="true" stroke-width="17" points="9.28340137 9.06261593 19.322441 9.06261593 44.0493062 ' +
  '75 54.1601338 75 78.8100832 9.06261593 88.6819593 9.06261593"></polyline></g></svg>';
